import _get from 'lodash/get';
import { Field } from '@sift/types';

// Recursively checks whether any of a field's parent fields are an array of objects
export default function parentFieldIsObjectArray(field: Field, fields: Field[]): boolean {
  if (!field.objectKey.includes('.')) return false;

  const parentFieldKey = field.objectKey.substring(0, field.objectKey.lastIndexOf('.'));
  const parentField = fields.find((field: Field) => field.objectKey === parentFieldKey);

  if (!parentField) return false;

  if (fieldIsObjectArray(parentField)) return true;

  return parentFieldIsObjectArray(parentField, fields);
}

// Checks whether a field is an array of objects (education, skills, pageCollection, etc)
function fieldIsObjectArray(field: Field) {
  const itemType = _get(field, 'item.type', '');

  return !!itemType && itemType.startsWith('@fields');
}
